import { AliveResponse } from '@quizdb/common';
import { quizdbApi } from '../api/quizdbApi';

export const aliveApi = quizdbApi.injectEndpoints({
  endpoints: (builder) => ({
    getAlive: builder.query<AliveResponse, void>({
      query: () => '/alive',
    }),
  }),
});

export const { useGetAliveQuery } = aliveApi;
